var stickyToggle = function (that, breakePoint, scrollElement) {
    if (scrollElement.scrollTop() >= breakePoint) {
        that.addClass("is-sticky").parent().height(that.outerHeight());
    }
    else {
        that.removeClass("is-sticky").parent().height("auto");
    }
};

$("[data-toggle='sticky-onscroll']").each(function (i, e) {
    var that = $(e), breakePoint = that.offset().top;

    // On page load
    stickyToggle(that, breakePoint, $(window));

    // Scroll & resize events
    $(window).on('scroll.sticky-onscroll resize.sticky-onscroll', function (o) {
        stickyToggle(that, breakePoint, $(o.currentTarget));
    });
});